export default __webpack_public_path__ + "static/media/possibility.525f13b6.png";